import { useMemo } from 'react';
import { ActivityList } from 'src/components/ActivityList/activity-list';
import {
  ActivityFeedParams,
  useActivityFeed,
} from 'src/graphql/entities/activity-feed/hooks/use-activity-feed';
import { buildMessagesByType } from './build-message-by-type';

export type ClientActivityProps = {
  clientId: string;
  partnerId: number;
};

export const ClientActivity = ({ partnerId, clientId }: ClientActivityProps) => {
  const params = useMemo<ActivityFeedParams>(
    () => ({
      identityIds: [clientId],
      partnerId,
      entityEvents: [
        {
          entityName: 'Client',
        },
        {
          entityName: 'ClientToAddress',
        },
      ],
    }),
    [clientId, partnerId],
  );

  const clientEmailParams = useMemo<ActivityFeedParams>(
    () => ({
      identityIds: [clientId],
      partnerId,
      isRoot: false,
      referenceName: 'Client',
      entityEvents: [
        {
          entityName: 'ClientEmail',
        },
        {
          entityName: 'ClientPhoneNumber',
        },
      ],
    }),
    [clientId, partnerId],
  );

  const { records: clientActivityFeed, loading } = useActivityFeed(params);
  const { records: clientContactsActivityFeed } = useActivityFeed(clientEmailParams);
  const records = useMemo(
    () => (clientActivityFeed ?? []).concat(clientContactsActivityFeed ?? []),
    [clientActivityFeed, clientContactsActivityFeed],
  );
  return (
    <ActivityList items={records} messageBuilder={buildMessagesByType} loading={loading} />
  );
};
